module.exports = __webpack_public_path__ + "img/Managers.daf35432.svg";